(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-comparison"] && !Shopify.designMode) return;
  try {
    
function initTimelineComparisons(root){root.querySelectorAll('[data-tl-compare]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const tabs=[...section.querySelectorAll('[role=tab]')];function select(tab){tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;const panel=document.getElementById(t.getAttribute('aria-controls'));panel.hidden=!active;if(active)panel.querySelector('.tl-compare-scroll').scrollLeft=0;});}tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();select(tabs[n]);tabs[n].focus();}});});});}initTimelineComparisons(document);document.addEventListener('shopify:section:load',e=>initTimelineComparisons(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-content"] && !Shopify.designMode) return;
  try {
    
function initTimelineContent(root){root.querySelectorAll('[data-tl-content]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const track=section.querySelector('[data-timeline-track]');if(track){const steps=[...track.querySelectorAll('[data-timeline-step]')],prev=section.querySelector('[data-timeline-prev]'),next=section.querySelector('[data-timeline-next]');let active=0;function select(index){active=index;steps.forEach((button,i)=>{const on=i===index;button.setAttribute('aria-expanded',String(on));button.closest('article').classList.toggle('is-active',on);document.getElementById(button.getAttribute('aria-controls')).hidden=!on;});prev.disabled=index===0;next.disabled=index===steps.length-1;track.scrollTo({left:steps[index].closest('article').offsetLeft-track.firstElementChild.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}steps.forEach((button,i)=>button.addEventListener('click',()=>select(i)));prev.addEventListener('click',()=>select(Math.max(0,active-1)));next.addEventListener('click',()=>select(Math.min(steps.length-1,active+1)));select(0);}const science=section.querySelector('[data-science-dialog]');if(science){let opener;const v=science.querySelector('video');section.querySelectorAll('[data-science-open]').forEach(button=>button.addEventListener('click',()=>{opener=button;science.querySelector('[data-science-title]').textContent=button.dataset.scienceTitle;v.replaceChildren();if(button.dataset.scienceCaption){const track=document.createElement('track');track.kind='captions';track.label='English';track.srclang='en';track.src=button.dataset.scienceCaption;v.append(track);}v.src=button.dataset.scienceSrc;science.showModal();v.play().catch(()=>{});}));science.addEventListener('close',()=>{v.pause();v.removeAttribute('src');v.load();opener?.focus();});}if(track){track.querySelectorAll('[data-timeline-video]').forEach(v=>{const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting&&v.closest('article').classList.contains('is-active')&&!matchMedia('(prefers-reduced-motion: reduce)').matches)v.play().catch(()=>{});else v.pause();}));observer.observe(v);});track.addEventListener('click',()=>{track.querySelectorAll('video').forEach(v=>{if(v.closest('article').classList.contains('is-active')&&!matchMedia('(prefers-reduced-motion: reduce)').matches)v.play().catch(()=>{});else v.pause();});});}const dialog=section.querySelector('[data-tl-study-dialog]');let opener;if(dialog){section.querySelectorAll('[data-tl-study-open]').forEach(button=>button.addEventListener('click',()=>{opener=button;dialog.querySelector('[data-study-dialog-title]').textContent=button.dataset.studyTitle;if(button.dataset.studyMethods)dialog.querySelector('[data-study-methods]').innerHTML=button.dataset.studyMethods;if(button.dataset.studyLimits)dialog.querySelector('[data-study-limits]').innerHTML=button.dataset.studyLimits;if(button.dataset.studySource)dialog.querySelector('.tl-study-source').href=button.dataset.studySource;dialog.showModal();dialog.scrollTop=0;}));dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});dialog.addEventListener('close',()=>opener?.focus());}const tabs=[...section.querySelectorAll('[data-tl-tab]')];function activate(tab){tabs.forEach(t=>{const selected=t===tab;t.setAttribute('aria-selected',String(selected));t.tabIndex=selected?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!selected;});}tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(i+1)%tabs.length;if(event.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;if(next!==undefined){event.preventDefault();activate(tabs[next]);tabs[next].focus();}});});});}initTimelineContent(document);document.addEventListener('shopify:section:load',event=>initTimelineContent(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-quality"] && !Shopify.designMode) return;
  try {
    
function initTimelineQuality(root){root.querySelectorAll('[data-tl-quality]').forEach(section=>{const video=section.querySelector('[data-quality-video]');if(!video||video.dataset.ready)return;video.dataset.ready='true';const reduced=matchMedia('(prefers-reduced-motion: reduce)'),controller=new AbortController();let frame=0,visible=false;function update(){frame=0;if(!visible||!Number.isFinite(video.duration))return;const r=section.getBoundingClientRect(),progress=Math.max(0,Math.min(1,(innerHeight-r.top)/(innerHeight+r.height))),time=reduced.matches?Math.min(1.5,video.duration-.05):progress*(video.duration-.05);if(!video.seeking&&Math.abs(video.currentTime-time)>.05)video.currentTime=time;}function queue(){if(!frame)frame=requestAnimationFrame(update);}video.addEventListener('loadeddata',()=>{video.dataset.loaded='true';queue();},{signal:controller.signal});video.addEventListener('seeked',queue,{signal:controller.signal});video.addEventListener('error',()=>{delete video.dataset.loaded;},{signal:controller.signal});const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible){const source=video.querySelector('source');if(source.dataset.src&&!source.src){source.src=source.dataset.src;video.load();}queue();}},{rootMargin:'200px'});observer.observe(section);window.addEventListener('scroll',queue,{passive:true,signal:controller.signal});window.addEventListener('resize',queue,{passive:true,signal:controller.signal});document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(section)){observer.disconnect();controller.abort();cancelAnimationFrame(frame);}},{signal:controller.signal});});}initTimelineQuality(document);document.addEventListener('shopify:section:load',e=>initTimelineQuality(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-reviews"] && !Shopify.designMode) return;
  try {
    
function initTimelineReviews(root){root.querySelectorAll('[data-tl-reviews]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const rows=[...section.querySelectorAll('[data-review-row]')],rating=section.querySelector('[data-review-rating]'),age=section.querySelector('[data-review-age]'),media=section.querySelector('[data-review-media]'),prev=section.querySelector('[data-review-prev]'),next=section.querySelector('[data-review-next]'),pages=section.querySelector('[data-review-pages]'),count=section.querySelector('[data-review-count]'),empty=section.querySelector('[data-review-empty]'),labels=section.querySelector('[data-review-labels]').dataset;let page=0;function render(){const found=rows.filter(row=>(!rating.value||row.dataset.rating===rating.value)&&(!age.value||row.dataset.age===age.value)&&(!media.checked||row.dataset.media==='true'));const total=Math.ceil(found.length/3);page=Math.max(0,Math.min(page,total-1));rows.forEach(row=>row.hidden=true);found.slice(page*3,page*3+3).forEach(row=>row.hidden=false);count.textContent=(found.length?((page*3+1)+'–'+Math.min(page*3+3,found.length)):'0')+' / '+found.length+' '+labels.reviews;empty.hidden=found.length!==0;prev.disabled=page===0;next.disabled=page>=total-1;pages.replaceChildren();for(let i=0;i<total;i++){const button=document.createElement('button');button.type='button';button.textContent=String(i+1);button.setAttribute('aria-label',labels.page+' '+(i+1));if(i===page)button.setAttribute('aria-current','page');button.addEventListener('click',()=>{page=i;render();});pages.append(button);}}[rating,age,media].forEach(input=>input.addEventListener('change',()=>{page=0;render();}));prev.addEventListener('click',()=>{page--;render();});next.addEventListener('click',()=>{page++;render();});section.querySelectorAll('[data-review-expand]').forEach(button=>button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!expanded));button.textContent=expanded?labels.more:labels.less;}));render();});}initTimelineReviews(document);document.addEventListener('shopify:section:load',event=>initTimelineReviews(event.target));

  } catch(e) { console.error(e); }
})();
})();
